module.exports = __webpack_public_path__ + "static/img/80060F_2_3_4_7_R_20181115_LC.079b248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80060F_2_3_4_7_R_20181115_LC.png
// module id = gmSU
// module chunks = 0